import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { metrics } from "../data/personalInfo";
import "./Metrics.css";

const Metrics = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section className="metrics" ref={ref}>
      <div className="container">
        <div className="metrics__grid">
          {metrics.map((metric, i) => (
            <motion.div
              key={i}
              className="metric-card"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: i * 0.1 }}
            >
              <span className="metric-card__value">{metric.value}</span>
              <span className="metric-card__label">{metric.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Metrics;
